$(function () {

  $("img").each(function() {

      $(this).attr("src",$(this).attr("data-data-src"));

  });
  
  //$(".shg-product-atc-btn-wrapper").attr('action', '/cart');
  $(window).scroll(function(){
   var sticky = $('.header-menus').offset().top;
   
    if($(window).scrollTop()>200){
      $('.header-menus').addClass('sticky');
    } 
    else{
     $('.header-menus').removeClass('sticky');
    }
  });
  
});
